<script lang="ts">
	import bookCoverImg from '@lib/images/placeholders/book-cover.webp?enhanced';
	import emptyBag3dIcon from '@lib/images/icons/3d/empty-bag.webp?enhanced';
	import { page } from '$app/stores';
	import { getDiscountPercentage, priceFormatter } from '@lib/helpers/global';
	import { formatPriceForDisplay } from '@lib/utils';

	$: ({ cartData } = $page.data);
</script>

<div class="w-96 rounded-xl border bg-base-100 p-6 shadow-soft">
	{#if cartData && cartData?.totalItems > 0}
		<div class="flex items-center justify-between border-b pb-2">
			<p class="font-semibold">Keranjang ({cartData.totalItems})</p>
			<a href="/cart" class="text-sm font-medium text-primary">Lihat Semua</a>
		</div>
		<div class="mt-3 grid max-h-80 overflow-y-auto">
			{#each cartData.items.slice(0, 5) as item}
				{@const selectedSubscriptionPlan = item.SubscriptionPlan.find((plan) => plan.is_selected)}
				<a
					href="/books/{item.slug}"
					class="group relative flex items-center gap-3 rounded-lg p-2.5 hover:bg-base-200/30"
				>
					<div class="book-cover">
						{#if item.image_url}
							<img class="size-full" src={item.image_url} alt={item.title} />
						{:else}
							<enhanced:img loading="lazy" class="size-full" src={bookCoverImg} alt={item.title} />
						{/if}
					</div>
					<div class="flex-1">
						<p class="line-clamp-1 text-balance text-sm font-medium">
							{item.title}
						</p>
						<div class="mt-1.5 space-y-0.5">
							{#if selectedSubscriptionPlan?.primary_price}
								<div class="flex items-center gap-2">
									<p class="text-xs font-medium text-error line-through">
										{priceFormatter.format(selectedSubscriptionPlan.primary_price)}
									</p>
									<p class="rounded-md bg-success/10 px-1 py-0.5 text-xs font-medium text-success">
										-{getDiscountPercentage(
											selectedSubscriptionPlan.primary_price,
											selectedSubscriptionPlan.price
										)}%
									</p>
								</div>
							{/if}
							<p class="text-lg font-semibold text-secondary">
								{formatPriceForDisplay(selectedSubscriptionPlan?.price)}
							</p>
							<p class="text-xs">{selectedSubscriptionPlan?.name}</p>
						</div>
					</div>
				</a>
			{/each}
		</div>
	{:else}
		<div class="text-center">
			<enhanced:img
				class="mx-auto mb-4 w-full max-w-32"
				src={emptyBag3dIcon}
				alt="Keranjang kosong"
			/>
			<p class="text-balance font-semibold">Wah, masih kosong nih keranjang Kamu</p>
			<p class="mt-1.5 text-sm text-gray-500">Yuk, isi sama buku-buku impian-mu!</p>
			<a href="/search" class="btn btn-outline btn-secondary btn-sm mt-4">Mulai Langganan Buku</a>
		</div>
	{/if}
</div>

<style lang="postcss">
	.book-cover {
		@apply aspect-[131/194] w-full max-w-20 overflow-hidden rounded-md object-cover object-center;
	}
</style>
